import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CreateYearDialogComponent } from './create-year-dialog.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { LocalizedNativeDateModule } from 'src/app/core/i18n/localized-date-adapter';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatMenuModule } from '@angular/material/menu';
import { NgxMaskDirective, NgxMaskPipe } from 'ngx-mask';
import { TranslocoModule } from '@ngneat/transloco';

@NgModule({
  declarations: [
    CreateYearDialogComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatDatepickerModule,
    LocalizedNativeDateModule,
    MatDialogModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatSlideToggleModule,
    FlexLayoutModule,
    MatSelectModule,
    MatMenuModule,
    MatTooltipModule,
    NgxMaskDirective,
    NgxMaskPipe,
    TranslocoModule
  ],
  exports: [
    CreateYearDialogComponent
  ],
})
export class CreateYearDialogModule { }
